import styled from 'styled-components';

export const boxFlex = styled.div`
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
`;

export const BoxFlexRow = styled(boxFlex)`
    flex-direction: row;
`;

export const ThreeDots = styled.span`
    max-width: ${({ maxWidth }) => maxWidth || '100%'};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    box-sizing: border-box;
    display: inline-block;
`;

export const DotForTextAtBeginning = styled.span`
    padding-left: 10px;
    position: relative;
    &:before {
        content: '';
        height: ${({ size }) => size || '3px'};
        width: ${({ size }) => size || '3px'};
        position: absolute;
        top: 50%;
        left: 3px;
        background: ${({ color }) => color || '#4f555e'};
        border-radius: 100%;
        transform: translateY(-50%);
        z-index: 1;
    }
`;

export const StyledPadding = styled.span`
    padding: ${({ padding }) => padding || '0 5px'};
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    gap: ${({ $gap }) => $gap};
    flex-wrap: ${({ $wrap }) => $wrap};
`;
export const Col = styled.div`
    width: ${({ $width }) => ($width ? $width : '100%')};
    margin: ${({ $margin }) => $margin};
    padding: ${({ $padding }) => $padding};
    flex-grow: ${({ $grow }) => $grow};
`;

export const BoxRoundedBorderBottom = styled.div`
    border: 1px solid ${({ theme }) => theme.borders.neutralBorder};
    border-top: none;
    border-radius: ${({ $borderRadius }) => $borderRadius || '0px 0px 4px 4px'};
    overflow: hidden;
`;

export const SectionTitle = styled.h2`
    font-size: ${({ $isMobile }) => ($isMobile ? '16px' : '20px')};
    line-height: ${({ $isMobile }) => ($isMobile ? '24px' : '32px')};
    font-weight: 700;
    color: ${({ theme }) => theme.text.neutralBlack};
    padding-left: ${({ $isMobile }) => ($isMobile ? '0' : '16px')};
    margin: ${({ $margin, $isMobile }) =>
        $margin ? $margin : $isMobile ? '0 0 8px' : '0 0 16px'};
`;

export const SectionWrapper = styled.section`
    width: 100%;
    padding-inline: ${({ $isMobile, $padding }) =>
        $padding ? $padding : $isMobile ? '16px' : '0'};
    box-sizing: border-box;
    margin: ${({ $margin }) => ($margin ? $margin : '0 0 16px')};
    overflow: hidden;
`;
